module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formField">\n    <select\n        ';
 if (multiple) { 
__p+='\n            multiple="multiple"\n        ';
 } 
__p+='\n        name="'+
((__t=(name))==null?'':_.escape(__t))+
'"\n        class="formField__select">\n        ';
 optGroups.forEach(function(optGroup) { 
__p+='\n        <!-- optgroup needs a default value for IE 10 otherwise the first child gets a wrong index  -->\n            ';
 if (optGroup.label) { 
__p+='<optgroup value="0" label="'+
((__t=( optGroup.label ))==null?'':_.escape(__t))+
'">';
 } 
__p+='\n                ';
 optGroup.options.forEach(function(option) { 
__p+='\n                    <option ';
 if (option.selected) { 
__p+='selected';
 } 
__p+='\n                        value="'+
((__t=( option.value ))==null?'':_.escape(__t))+
'">\n                        '+
((__t=( option.name ))==null?'':_.escape(__t))+
'\n                    </option>\n            ';
 }); 
__p+='\n            ';
 if (optGroup.label) { 
__p+='</optgroup>';
 } 
__p+='\n        ';
 }); 
__p+='\n    </select>\n</div>\n';
}
return __p;
};
